import { render, staticRenderFns } from "./ReceivedCi.vue?vue&type=template&id=6f368d9a&"
import script from "./ReceivedCi.vue?vue&type=script&lang=js&"
export * from "./ReceivedCi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports